import { BioPage } from "../components/BioPage";
import { IMAGES, SITE } from "../config/site";

const INTRO = [
  "Attorney Valencia King, Esq. was born and raised in Dallas, Texas. Her interest in law began during her undergraduate studies at Prairie View A&M University, where she earned a bachelor's degree in Criminal Justice.",
  "She later earned a Master of Business Administration before attending the University of Illinois Chicago School of Law, where she received her Juris Doctor.",
  "During law school, Attorney King served as Vice President and Secretary of the Black Law Students Association, Secretary of the Entertainment and Sports Law Society, and a Student Ambassador for GrammyU, an initiative of The Recording Academy.",
  "She also served as a council member on the Trial Advocacy and Dispute Resolution Board, where she was selected to compete in local and national mock-trial competitions.",
  "Attorney King's work primarily focuses on trademark law. Her experience includes conducting preliminary trademark searches, preparing trademark applications, and assisting with responses to office actions issued by the United States Patent and Trademark Office.",
  "Her goal is to help creatives and entrepreneurs pursue their ambitions through reliable, transparent, and high-quality legal support.",
];

const SECTIONS = [
  {
    title: "Education", type: "pairs",
    items: [
      { label: "Prairie View A&M University", value: "Bachelor's Degree in Criminal Justice" },
      { label: "Master of Business Administration", value: "MBA" },
      { label: "University of Illinois Chicago School of Law", value: "Juris Doctor" },
    ],
  },
  {
    title: "Leadership & Involvement", type: "list",
    items: [
      "Black Law Students Association",
      "Entertainment and Sports Law Society",
      "GrammyU Student Ambassador",
      "Trial Advocacy and Dispute Resolution Board",
      "Local and national mock-trial competitions",
    ],
  },
  {
    title: "Trademark Experience", type: "list",
    items: [
      "Preliminary trademark searches",
      "Trademark application preparation",
      "USPTO office-action response support",
      "Brand-protection guidance for creatives and entrepreneurs",
    ],
  },
];

export default function ValenciaBio() {
  return (
    <BioPage
      testid="valencia-bio"
      seo={{
        title: `Valencia King | ${SITE.valenciaTitle} | Nolen Law Chicago`,
        description:
          "Valencia King focuses on trademark law, helping creatives and entrepreneurs with searches, applications, and USPTO office-action responses at Nolen Law in Chicago.",
        path: "/team/valencia-king",
        image: IMAGES.valencia,
      }}
      image={IMAGES.valencia}
      imageAlt={`Valencia King, ${SITE.valenciaTitle} at The Law Office of Ronald K. Nolen, LLC`}
      eyebrow="Trademark Practice"
      name="Valencia King, Esq."
      subheadline="Helping creatives and entrepreneurs protect the ideas, names, and brands they are building."
      intro={INTRO}
      sections={SECTIONS}
      finalHeadline="Protect the Brand You're Building"
    />
  );
}
